import React from 'react';

const MyPortfolio = () => {
    return (
        <div>

        </div>
    );
};

export default MyPortfolio;